export const NEWS_FRAGMENT = `
fragment NewsFragment on News {
  id
  title
  text
  image
  createdAt
}
`
